import { ILocalStore } from '@/stores/interfaces/ILocalStore';

import { TabsStore } from '../../shared/TabsStore';
import { FieldTextStore } from '../../shared/form/FieldTextStore';

import { FollowUpStore } from './FollowUpStore';
import { InsightsStore } from './InsightsStore';
import { NotesStore } from './NotesStore';
import { TabOption, TABS_ITEMS, NotesTabsKeys } from './types';

export type SidebarNoteStoreParams = {
  organizationId: number;
};

export class SidebarNoteStore implements ILocalStore {
  readonly tabs: TabsStore<TabOption>;
  readonly notes: NotesStore;
  readonly insights: InsightsStore;
  readonly followUp: FollowUpStore;
  readonly filedText = new FieldTextStore();

  constructor({ organizationId }: SidebarNoteStoreParams) {
    this.notes = new NotesStore({ organizationId: String(organizationId) });
    this.insights = new InsightsStore({ organizationId: String(organizationId) });
    this.followUp = new FollowUpStore({ organizationId: String(organizationId) });
    this.tabs = new TabsStore({
      items: TABS_ITEMS,
      defaultActiveKey: NotesTabsKeys.notes,
    });
  }

  destroy() {
    this.notes.destroy();
    this.followUp.destroy();
    this.tabs.destroy();
    this.filedText.destroy();
    this.insights.destroy();
  }
}
